var map = {
	"./": 18305,
	"./App": 18496,
	"./App.js": 18496,
	"./App.scss": 5636,
	"./App.test": 60754,
	"./App.test.js": 60754,
	"./Components/ImageUpload": 89781,
	"./Components/ImageUpload.js": 89781,
	"./Components/Link": 38229,
	"./Components/Link.js": 38229,
	"./Components/ToastStyles.css": 70689,
	"./bsky.png": 42934,
	"./critterbadge3.png": 97309,
	"./custom-cursor.cur": 45469,
	"./index": 18305,
	"./index.js": 18305,
	"./index.scss": 50277,
	"./logo.svg": 31100,
	"./reportWebVitals": 54013,
	"./reportWebVitals.js": 54013,
	"./setupTests": 79511,
	"./setupTests.js": 79511
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 18116;